module.exports = __webpack_public_path__ + "static/banner-282fc8dc6b19dbcb8352ce6cef14ea0a.jpg";